import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { extensionDecorator, ExtensionPriority, NodeExtension, ExtensionTag, setBlockType } from '@remirror/core';

var _dec, _class, _temp;
/**
 * The paragraph is one of the essential building blocks for a prosemirror
 * editor and by default it is provided to all editors.
 *
 * @core
 */

var ParagraphExtension = (_dec = /*#__PURE__*/extensionDecorator({
  defaultPriority: ExtensionPriority.Medium
}), /*#__PURE__*/_dec(_class = (_temp = class ParagraphExtension extends NodeExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "tags", [ExtensionTag.LastNodeCompatible, ExtensionTag.BlockNode]);
  }

  get name() {
    return 'paragraph';
  }

  createNodeSpec(extra) {
    return {
      content: 'inline*',
      attrs: _objectSpread({}, extra.defaults()),
      draggable: false,
      parseDOM: [{
        tag: 'p',
        getAttrs: node => _objectSpread({}, extra.parse(node))
      }],
      toDOM: node => {
        return ['p', extra.dom(node), 0];
      }
    };
  }
  /**
   * Provides the commands that this extension uses.
   */


  createCommands() {
    return {
      createParagraph: attributes => {
        return setBlockType(this.type, attributes);
      }
    };
  }

}, _temp)) || _class);

export { ParagraphExtension };
